import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-pharmacy-consents',
	templateUrl: './modal-pharmacy-consents.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalPharmacyConsentsComponent implements OnInit {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalPharmacyConsentsComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.initialize();
		
		this.vm.close = this.close;
		this.vm.submit = this.submit;
	}
	
	initialize() {
		this.vm.consents = {};
		
		this.vm.processing = false;
		this.vm.initialized = true;
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing || !this.vm.initialized) return;
		this.vm.processing = true;
		
		var promises: Array<any> = [];
		promises.push(this.getRedirectLink());
		
		this.angularHelperService.getPromise().all(promises)
			.then((res) => {
				if (res[0] && res[0].redirectUrl) {
					window.open(res[0].redirectUrl, '_blank');
				}
				this.vm.processing = false;
				this.dialogRef.close(this.vm.booking);
			}, (err) => {
				this.vm.processing = false;
			});
	}
	
	getRedirectLink() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.serviceRestServices.getPharmacyRedirectLink(this.vm.booking,
			(res) => {
				deferred.resolve(res);
			},
			() => {
				deferred.reject('components/modal-pharmacy-consents getRedirectLink - failed to fetch redirect link');
			}
		);
		
		return deferred.promise;
	}
	
	close() {
		this.dialogRef.close(this.vm.booking);
	}
	
}